import chatbotRequest from '@/service/channel/http'
import type { CreateBroadcastTaskReq, CreateBroadcastTaskRes } from '../types/createBroadcastTask'

export function createBroadcastTaskApi(data: CreateBroadcastTaskReq): Promise<CreateBroadcastTaskRes> {
    return chatbotRequest<CreateBroadcastTaskRes, CreateBroadcastTaskReq, CreateBroadcastTaskRes>({
        url: '/api/broadcast/telegram/task/create',
        method: 'post',
        data,
    })
}